// Bootstrap imports
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

// Library imports
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { ThemeProvider } from "styled-components";
import { client } from "data/apollo";
import { ApolloProvider } from "@apollo/client";
import { theme } from "./theme";
import { config } from "./config";

// Style imports
import "./index.css";
import "bootstrap-css-only/css/bootstrap.min.css";

ReactDOM.render(
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <Router basename={config.publicUrl}>
        <App />
      </Router>
    </ThemeProvider>
  </ApolloProvider>,
  document.getElementById("root")
);
